module.exports = __webpack_public_path__ + "static/service-contract-mobile-33e909462a994227f5bb9d907b749e36.svg";